module.exports = __webpack_public_path__ + "img/learn_balloon1_sp.04606cea.svg";